import {Component, ElementRef, EventEmitter, inject, Input, OnInit, Output} from '@angular/core';
import {TranslatePipe} from '../../filters/translate.pipe';
import {CommonModule} from '@angular/common';
import AngularHelperService from '../../services/angular-helper.service';
import AngularFilterHelperService from "../../services/angular-filter-helper.service";


@Component({
    standalone: true,
    selector: 'symptom-list-popover',
    templateUrl: './symptom-list-popover.component.html',
    imports: [ TranslatePipe, CommonModule]
})

export class SymptomListPopoverComponent implements OnInit {
    private angularHelperService: AngularHelperService = inject(AngularHelperService);
    private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
    vm: any = undefined;
    watcher: any = undefined;

    allSelectedSymptoms: { id: number; name: string, bodyPart: string }[] = [];

    @Input() bodyPartSymptomNames: { id: number; name: string, bodyPart: string }[] = [];
    @Input() wrapper: any | undefined;
    @Input() placement: any | undefined;
    @Input() placementMobile: any | undefined;
    @Input() initialSelectedSymptoms: { id: number; name: string, bodyPart: string }[] = []; // To store initially selected symptoms

    @Output() isPopoverOpen = new EventEmitter<void>();
    @Output() selectedSymptomsChange = new EventEmitter<{ id: number; name: string, bodyPart: string }[]>();


    constructor(private elementRef: ElementRef) {
        this.vm = this;
    }

    ngOnInit(): void {

        this.allSelectedSymptoms = [...this.initialSelectedSymptoms];
        this.vm.toggleSymptomSelection = this.toggleSymptomSelection;
        this.vm.isSelected = this.isSelected;
        this.vm.getTranslatedBodyPart = this.getTranslatedBodyPart;

        this.vm.mobileBreakpoint = 768;
        this.vm.placement = this.vm.placement || 'bottom';
        this.vm.placementMobile = this.vm.placementMobile || this.vm.placement;

        this.vm.bodyPartSymptomNames = this.bodyPartSymptomNames;

        this.vm.element = this.angularHelperService.element(this.elementRef.nativeElement);
        this.vm.isOpen = true;

        this.angularHelperService.element(this.angularHelperService.getWindow()).on('resize', () => { this.handleParamsUpdate(); });


        var currentIsOpen = this.vm.isOpen;
        this.watcher = this.angularHelperService.createInterval(() => {
            var newIsOpen = this.vm.isOpen;
            if (currentIsOpen !== newIsOpen) {
                currentIsOpen = newIsOpen;
                this.handleIsOpenChange(newIsOpen);
            }
        }, 100);

        this.vm.handleCloseButtonClick = this.handleCloseButtonClick;
    }

    handleCloseButtonClick() {
        this.vm.isOpen = false;
        this.isPopoverOpen.emit();
    }

    handleIsOpenChange(isOpen) {
        if (isOpen) {
            requestAnimationFrame(() => {
                var modifiers: any = { flip: { behavior: [this.vm.placement, this.vm.placementMobile] } };
                if (this.vm.popperWrapper) modifiers.preventOverflow = { boundariesElement: this.vm.popperWrapper };

                this.vm.popoverElement = this.vm.element[0].querySelector('.symptom-popover');
            });
        }
    }

    ngOnDestroy() {
        this.angularHelperService.element(this.angularHelperService.getWindow()).off('resize', () => { this.handleParamsUpdate(); });
        if (this.watcher) {
            this.angularHelperService.cancelInterval(this.watcher);
        }
    }

    handleParamsUpdate() {
        if (window.innerWidth < this.vm.mobileBreakpoint) {
            this.vm.popperPlacement = this.vm.placementMobile;
            this.vm.popperWrapper = this.vm.wrapperMobile;
        } else {
            this.vm.popperPlacement = this.vm.placement;
            this.vm.popperWrapper = this.vm.wrapper;
        }
    }

    toggleSymptomSelection(symptom: { id: number; name: string, bodyPart: string }): void {
        if (!this.allSelectedSymptoms.some(s => s.id === symptom.id)) {
            this.allSelectedSymptoms.push(symptom);
        }
        // Emit the updated list of selected symptoms and close the popover
        this.selectedSymptomsChange.emit(this.allSelectedSymptoms);
        this.isPopoverOpen.emit();
    }

    isSelected(symptom: { id: number; name: string, bodyPart: string }): boolean {
        return this.allSelectedSymptoms.some(s => s.id === symptom.id);
    }

    getTranslatedBodyPart(bodyPart: string) {
        return this.angularFilterHelperService.translate('Symptom_Check.Body_Parts.' + bodyPart);
    }

    ngAfterViewInit(): void {
        console.log(this.elementRef.nativeElement); // Ensure it's defined here
    }
}